import {
  NpcStorageAction,
  NpcStorageActionTypes,
  NpcStorageState,
} from '../../types/npcStorage';

const initialState: NpcStorageState = {
  totalQty: 0,
  totalAmount: 0,
  totalAverage: 0,
  chart: [],
  table: [],
  brand: {
    table: [],
    headers: [],
  },
  lists: {
    brands: [],
    categories: [],
    sizes: [],
  },
  min_date: null,
  loading: true,
  loading_brand: true,
  loading_lists: true,
};

export const npcStorageReducer = (
  state = initialState,
  action: NpcStorageAction
): NpcStorageState => {
  switch (action.type) {
    case NpcStorageActionTypes.GET_NPC_STORAGE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case NpcStorageActionTypes.GET_NPC_STORAGE_BRAND:
      return {
        ...state,
        brand: {
          ...state.brand,
          ...action.payload,
        },
        loading_brand: false,
      };
    case NpcStorageActionTypes.GET_NPC_STORAGE_PARAMS:
      return {
        ...state,
        lists: {
          ...state.lists,
          ...action.payload,
        },
        loading_lists: false,
      };
    case NpcStorageActionTypes.SET_NPC_STORAGE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case NpcStorageActionTypes.SET_NPC_STORAGE_BRAND_LOADING:
      return {
        ...state,
        loading_brand: true,
      };
    case NpcStorageActionTypes.GET_NPC_STORAGE_MINDATE:
      return {
        ...state,
        min_date: action.payload,
      };
    case NpcStorageActionTypes.CLEAR_NPC_STORAGE:
      return initialState;
    default:
      return state;
  }
};
